import { TicketSales } from '@features';
import { useTranslation } from 'react-i18next';
import { PageLayout } from '../_layout';

export const TicketSalesPage: React.FC = () => {
  const { t } = useTranslation('ticketSales');

  return (
    <PageLayout title={t('TITLE')}>
      <TicketSales />
    </PageLayout>
  );
};
